export interface SessionData {
  isCSR?: boolean
  isCSRSupervisor?: boolean
  wellType: number
  plateName: string
  researcher: string
  channelType: number
  plateType: string
  countryCode: string
  totalBaseCount: number
  plateId: number
  countOfWells: number
  material?: string
  isAmountSelected?: boolean
  isConcentrationSelected?: boolean
  purification: string
  format: string
  concentration: string
  amount: string
  scale: string
  daughterPlateCount?: string
  isOverridden: boolean
  isSpecificationsOverridden?: boolean
  isShippingOverridden?: boolean
  isPackageTypeOther?: boolean
  minAmount?: string
  maxAmount?: string
  plateCopiesRange?: string
  pageNo: number
  applyToAll: boolean
  researcherNameError: string[]
  plateNameError: string[]
  category: string
  packageType: string
  shipping: string
  stockPlate: string
  selectedPackageType: string
  isConcentrationOther: boolean
  productType: string
  __typename?: string
  wellList: WellList[]
  biTubeWellList: BiTubeWellList[]
}
export interface WellList {
  id: number
  wellType: number
  mixed?: number | null
  oligoId: number
  name: string
  sequence: string
  baseCount: number
  threeMod: string
  fiveMod: string
  format: string
  other: string
  purification: string
  concentration: string
  scale: string
  countryCode: string
  productType: string
  technicalSequence: string | null | undefined
  amount: string
  tubes: number
  terms: boolean
  flag: number
  row: string
  column: string
  comments: string
  additionalComments: string
  isOverridden: boolean
  orderItemId: string
  pageNo: number
  packageType: string
  shipping: string
  excessMaterial: boolean
  molecularWeight?: string
  primerDimer: string
  secondaryStructure: string
  gcContent: string
  meltingTemparature: string
  epsilon: number
  listError: ListErrorType[]
  listWarning: ListWarningType[]
  category: string
  __typename?: string
}
export interface BiTubeWellList {
  antisenceBaseCount: number
  antisenceName: string
  antisenceSequence: string
  autoGenerateOligo: boolean
  customerOverhang: string
  customerAntisenseOverHang: string
  antisenceFiveMod: string
  antisenceThreeMod: string
  id: number
  name: string
  sequence: string
  baseCount: number
  threeMod: string
  fiveMod: string
  format: string
  purification: string
  concentration: string
  countryCode: string
  productType: string
  scale: string
  tubes: number
  autoValidation: boolean
  comments: string
  additionalComments: string
  isOverridden: boolean
  orderItemId: string
  amount: string
  senseNameCheck: boolean
  row: string
  column: string
  technicalAntisenceSequence: string
  technicalSequence: string
  pageNo: number
  packageType: string
  shipping: string
  terms: boolean
  molecularWeight: string
  primerDimer: string
  secondaryStructure: string
  gcContent: string
  meltingTemparature: string
  antisenseMolecularWeight: string
  antisensePrimerDimer: string
  antisenseMeltingTemparature: string
  antisenseGcContent: string
  antisenseSecondaryStructure: string
  listError: ListErrorType[]
  listWarning: ListWarningType[]
  __typename?: string
}

export interface RuleValidationPlateData {
  name: string
  sequence: string
  threeMod: string
  fiveMod: string
  tubes: number
  pageNo: number
  isOverridden: boolean
  wellType: number
  mixed?: number | null
}
export interface RuleValidationPlateDataMixed {
  name: string
  sequence: string
  threeMod: string
  fiveMod: string
  tubes: number
  pageNo: number
  isOverridden: boolean
  wellType: number
  mixed?: number | null
}
export interface RuleValidationDuplexData {
  pageNo: number
  antisenceBaseCount: number
  antisenceFiveMod: string
  antisenceName: string
  antisenceSequence: string
  antisenceThreeMod: string
  baseCount: number
  customerAntisenseOverHang: string
  customerOverhang: string
  fiveMod: string
  isOverridden: boolean
  name: string
  sequence: string
  threeMod: string
  tubes: number
  autoGenerateOligo: boolean
}
export interface RuleValidationPlateResponse {
  listErrors: ListErrorType[]
  listWarning: ListWarningType[]
  listFiveMod: string[]
  listThreeMod: string[]
  listScale: string[]
  listPurification: string[]
  listModification: string[]
  listFormat: string[]
  listConcentration: string[]
  listTubes: string[]
  listAmount: string[]
  listPurityLevel: string[]
  listNterminalMod: string[]
  listCterminalMod: string[]
  listQuantitation: string[]
  listInternalMod: string[]
  listOverhang: string[]
  baseCount: number
  antisenseBaseCount: number
  molecularWeight: string
  primerDimer: string
  meltingTemperature: string
  secondaryStructure: string
  gcContent: string
  antisenseMolecularWeight: string
  antisensePrimerDimer: string
  antisenseMeltingTemperature: string
  antisenseGcContent: string
  antisenseSecondaryStructure: string
}
export interface PlateShippingResponse {
  listShipment: string[]
  listExcessMaterial: string[]
  listProductPackage: string[]
}
export interface RuleValidationPlateResponseMixed {
  listErrors: ListErrorType[]
  listWarning: ListWarningType[]
  listFiveMod: string[]
  listThreeMod: string[]
  listScale: string[]
  listPurification: string[]
  listModification: string[]
  listFormat: string[]
  listConcentration: string[]
  listTubes: string[]
  listAmount: string[]
  listPurityLevel: string[]
  listNterminalMod: string[]
  listCterminalMod: string[]
  listQuantitation: string[]
  listInternalMod: string[]
  listOverhang: string[]
  baseCount: number
  antisenseBaseCount: number
  molecularWeight: string
  primerDimer: string
  meltingTemperature: string
  secondaryStructure: string
  gcContent: string
  antisenseMolecularWeight: string
  antisensePrimerDimer: string
  antisenseMeltingTemperature: string
  antisenseGcContent: string
  antisenseSecondaryStructure: string
}
export interface WellSpecificationResponse {
  id: number
  listPurification: string[]
  listScale: string[]
  listFormat: string[]
  listAmount: string[]
}
export interface IntersectionValues {
  listPurification: string[]
  listScale: string[]
  listFormat: string[]
  listAmount: string[]
}
export interface ListErrorType {
  key: string
  value: string
  __typename?: string
}
export interface ListWarningType {
  key: string
  value: string
  __typename?: string
}
export interface PlateTotalValidation {
  error: string
  wellList: WellListResponse[]
  biTubeWellList: DuplexWellListResponse[]
}
export interface WellListResponse {
  countryCode: string
  id: number
  oligoId: number
  listError: ListErrorType[]
  errorType: string
}
export interface DuplexWellListResponse {
  countryCode: string
  id: number
  oligoId: number
  listError: ListErrorType[]
  listWarning: ListWarningType[]
  errorType: string
}
export interface SpecificationCalculationInput {
  format: string
  purification: string
  concentration: string
  scale: string
  amount: string
  fiveMod: string
  threeMod: string
  sequence: string
  category: string
  plateType: string
  daughterPlateNumber: string
  wellType: number
  listScaleFromRules: [string]
  isamountValidate: boolean
  isConcentrationValidate: boolean
  isOverriden: boolean
  isConcentrationChanged: boolean
  isAmountChanged: boolean
  isVolumeChanged: boolean
  maxAmount: number
  maxVolume: number
  maxConcentration: number
}
export interface SpecifictionCalculationResponse {
  errorValues: ErrorValues[]
  calculatedValues: CalculatedValues
}
export interface ErrorValues {
  valid: string
  validationType: string
  key: string
}
export interface CalculatedValues {
  amount: string
  maxConcentration: number
  scale: string
  daughterPlateRange: number
  maxAmount: number
  maxVolume: number
  minVolume: number
}
export interface PlatePriceCallResponse {
  currency: string
  brand: string
  material: string
  currencySymbol: string
  baseFee: string
  modificationFee: string
  purificationFee: string
  plateCopyFee: string
  shippingOptionFee: string
  remainingMaterials: string
  plateId: number
  plateName: string
  totalPrice: string
  errorType: string
  priceErrorHeader: string
  plateFee: string
  processFee: string
  wells: string
}
export interface ProductInformationResponse {
  productType?: string | null | undefined
  typeCode?: string | null | undefined
  packageType?: string | null | undefined
  instructions?: string | null | undefined
  brand?: string | null | undefined
  shippingOptions?: any[] | null | undefined
  companionProducts?: any[] | null | undefined
  currencyFormat?: string
  decimalSeparator?: string
  thousandSeparator?: string
  prefixCurrecny?: boolean
  thousandSpacing?: string
}

export interface PlateState {
  sessionData: SessionData[]
  errorData: RuleValidationPlateData
  errorDataMixed: RuleValidationPlateDataMixed
  errorDataDuplex: RuleValidationDuplexData
  errorResponseJson: RuleValidationPlateResponse
  errorResponseJsonMixed: RuleValidationPlateResponseMixed
  stepNo: number
  currentPlateIndex: number
  currentWellIndex: number
  totalValidation: PlateTotalValidation[]
  wellSpecifications: WellSpecificationResponse[]
  intersectionValues: IntersectionValues
  specificationCalculationInput: SpecificationCalculationInput
  wellList: WellList[]
  biTubeWellList: BiTubeWellList[]
  specificationCalculationResponse: SpecifictionCalculationResponse
  plateShippingResponse: PlateShippingResponse
  platePriceCall: PlatePriceCallResponse[]
  productInformation: ProductInformationResponse
  pageError: string
  minimumWellsError: boolean
  isPageLoad: boolean
  isPlateDeleted: boolean
}
export const ListError = {
  key: '',
  value: '',
  __typename: '',
}
export const ListWarning = {
  key: '',
  value: '',
  __typename: '',
}
export const emptyWellList = {
  id: 0,
  oligoId: 0,
  name: '',
  sequence: '',
  baseCount: 0,
  threeMod: '',
  fiveMod: '',
  format: '',
  other: '',
  purification: '',
  concentration: '',
  scale: '',
  countryCode: '',
  productType: '',
  technicalSequence: '',
  amount: '',
  tubes: 1,
  terms: false,
  flag: 0,
  row: '',
  column: '',
  comments: '',
  additionalComments: '',
  isOverridden: false,
  orderItemId: ' ',
  pageNo: 0,
  packageType: '',
  shipping: '',
  excessMaterial: false,
  wellType: 0,
  molecularWeight: '',
  primerDimer: '',
  secondaryStructure: '',
  gcContent: '',
  meltingTemparature: '',
  epsilon: 0,
  listError: [],
  listWarning: [],
  category: '',
}

export const emptyDuplexWellList = {
  additionalComments: '',
  amount: '',
  antisenceBaseCount: 0,
  antisenceFiveMod: '',
  antisenceName: '',
  antisenceSequence: '',
  antisenceThreeMod: '',
  antisenseGcContent: '',
  antisenseMeltingTemparature: '',
  antisenseMolecularWeight: '',
  antisensePrimerDimer: '',
  antisenseSecondaryStructure: '',
  autoGenerateOligo: false,
  autoValidation: false,
  baseCount: 0,
  column: '',
  comments: '',
  concentration: '',
  countryCode: '',
  customerAntisenseOverHang: '',
  customerOverhang: '',
  fiveMod: '',
  format: '',
  gcContent: '',
  id: 0,
  isOverridden: false,
  listError: [],
  listWarning: [],
  meltingTemparature: '',
  molecularWeight: '',
  name: '',
  orderItemId: '',
  packageType: '',
  pageNo: 0,
  primerDimer: '',
  productType: '',
  purification: '',
  row: '',
  scale: '',
  secondaryStructure: '',
  senseNameCheck: false,
  sequence: '',
  shipping: '',
  technicalAntisenceSequence: '',
  technicalSequence: '',
  terms: false,
  threeMod: '',
  tubes: 0,
}

export const EmptyResponse = {
  antisenseBaseCount: 0,
  antisenseGcContent: '0.0',
  antisenseMeltingTemperature: '0.0',
  antisenseMolecularWeight: '0.0',
  antisensePrimerDimer: 'No',
  antisenseSecondaryStructure: 'NONE',
  baseCount: 0,
  gcContent: '0.0',
  listAmount: [''],
  listConcentration: [''],
  listCterminalMod: [],
  listErrors: [],
  listFiveMod: [],
  listFormat: [''],
  listInternalMod: [''],
  listModification: [''],
  listNterminalMod: [],
  listOverhang: [],
  listPurification: [''],
  listPurityLevel: [''],
  listQuantitation: [''],
  listScale: [''],
  listThreeMod: [],
  listTubes: [''],
  listWarning: [],
  meltingTemperature: '0.0',
  molecularWeight: '0.0',
  primerDimer: 'No',
  secondaryStructure: 'NONE',
}

export const EmptyWellSpecification = {
  id: 0,
  listPurification: [''],
  listScale: [''],
  listFormat: [''],
}
export const EmptyState = {
  isCSR: false,
  isCSRSupervisor: false,
  wellType: 0,
  plateName: 'New Plate',
  researcher: '',
  channelType: 0,
  plateType: '',
  countryCode: '',
  totalBaseCount: 0,
  plateId: 1,
  countOfWells: 0,
  material: '',
  isAmountSelected: false,
  isConcentrationSelected: false,
  purification: '',
  format: '',
  concentration: '',
  amount: '',
  scale: '',
  daughterPlateCount: '',
  isOverridden: false,
  isSpecificationsOverridden: false,
  isShippingOverridden: false,
  isPackageTypeOther: false,
  minAmount: '',
  maxAmount: '',
  plateCopiesRange: '',
  pageNo: 0,
  applyToAll: false,
  researcherNameError: [],
  plateNameError: [],
  category: '',
  packageType: '',
  shipping: '',
  stockPlate: '',
  selectedPackageType: '',
  isConcentrationOther: false,
  wellList: [emptyWellList],
  biTubeWellList: [emptyDuplexWellList],
  productType: '',
}
export const EmptyPrice = {
  currency: '',
  currencySymbol: '',
  brand: '',
  material: '',
  baseFee: '',
  modificationFee: '',
  purificationFee: '',
  plateCopyFee: '',
  shippingOptionFee: '',
  remainingMaterials: '',
  plateId: 1,
  plateName: '',
  totalPrice: '',
  errorType: '',
  priceErrorHeader: '',
  plateFee: '',
  processFee: '',
  wells: '',
}

export const initialState: PlateState = {
  biTubeWellList: [
    {
      additionalComments: '',
      amount: '',
      antisenceBaseCount: 0,
      antisenceFiveMod: '',
      antisenceName: '',
      antisenceSequence: '',
      antisenceThreeMod: '',
      antisenseGcContent: '',
      antisenseMeltingTemparature: '',
      antisenseMolecularWeight: '',
      antisensePrimerDimer: '',
      antisenseSecondaryStructure: '',
      autoGenerateOligo: false,
      autoValidation: false,
      baseCount: 0,
      column: '',
      comments: '',
      concentration: '',
      countryCode: '',
      customerAntisenseOverHang: '',
      customerOverhang: '',
      fiveMod: '',
      format: '',
      gcContent: '',
      id: 0,
      isOverridden: false,
      listError: [],
      listWarning: [],
      meltingTemparature: '',
      molecularWeight: '',
      name: '',
      orderItemId: '',
      packageType: '',
      pageNo: 0,
      primerDimer: '',
      productType: '',
      purification: '',
      row: '',
      scale: '',
      secondaryStructure: '',
      senseNameCheck: false,
      sequence: '',
      shipping: '',
      technicalAntisenceSequence: '',
      technicalSequence: '',
      terms: false,
      threeMod: '',
      tubes: 0,
    },
  ],
  currentPlateIndex: 0,
  currentWellIndex: 0,
  errorData: {
    fiveMod: '',
    isOverridden: false,
    name: '',
    pageNo: 0,
    sequence: '',
    threeMod: '',
    tubes: 1,
    wellType: 0,
  },
  errorDataDuplex: {
    antisenceBaseCount: 0,
    antisenceFiveMod: '',
    antisenceName: '',
    antisenceSequence: '',
    antisenceThreeMod: '',
    autoGenerateOligo: false,
    baseCount: 0,
    customerAntisenseOverHang: '',
    customerOverhang: '',
    fiveMod: '',
    isOverridden: false,
    name: '',
    pageNo: 0,
    sequence: '',
    threeMod: '',
    tubes: 1,
  },
  errorDataMixed: {
    fiveMod: '',
    isOverridden: false,
    name: '',
    pageNo: 0,
    sequence: '',
    threeMod: '',
    tubes: 1,
    wellType: 0,
  },
  errorResponseJson: {
    antisenseBaseCount: 0,
    antisenseGcContent: '0.0',
    antisenseMeltingTemperature: '0.0',
    antisenseMolecularWeight: '0.0',
    antisensePrimerDimer: 'No',
    antisenseSecondaryStructure: 'NONE',
    baseCount: 0,
    gcContent: '0.0',
    listAmount: [''],
    listConcentration: [''],
    listCterminalMod: [],
    listErrors: [],
    listFiveMod: [],
    listFormat: [''],
    listInternalMod: [''],
    listModification: [''],
    listNterminalMod: [],
    listOverhang: [],
    listPurification: [''],
    listPurityLevel: [''],
    listQuantitation: [''],
    listScale: [''],
    listThreeMod: [],
    listTubes: [''],
    listWarning: [],
    meltingTemperature: '0.0',
    molecularWeight: '0.0',
    primerDimer: 'No',
    secondaryStructure: 'NONE',
  },
  errorResponseJsonMixed: {
    antisenseBaseCount: 0,
    antisenseGcContent: '0.0',
    antisenseMeltingTemperature: '0.0',
    antisenseMolecularWeight: '0.0',
    antisensePrimerDimer: 'No',
    antisenseSecondaryStructure: 'NONE',
    baseCount: 0,
    gcContent: '0.0',
    listAmount: [''],
    listConcentration: [''],
    listCterminalMod: [],
    listErrors: [],
    listFiveMod: [],
    listFormat: [''],
    listInternalMod: [''],
    listModification: [''],
    listNterminalMod: [],
    listOverhang: [],
    listPurification: [''],
    listPurityLevel: [''],
    listQuantitation: [''],
    listScale: [''],
    listThreeMod: [],
    listTubes: [''],
    listWarning: [],
    meltingTemperature: '0.0',
    molecularWeight: '0.0',
    primerDimer: 'No',
    secondaryStructure: 'NONE',
  },
  intersectionValues: {
    listAmount: [],
    listFormat: [],
    listPurification: [],
    listScale: [],
  },
  isPageLoad: false,
  isPlateDeleted: false,
  minimumWellsError: false,
  pageError: '',
  platePriceCall: [
    {
      baseFee: '',
      brand: '',
      currency: '',
      currencySymbol: '',
      errorType: '',
      material: '',
      modificationFee: '',
      plateCopyFee: '',
      plateFee: '',
      plateId: 1,
      plateName: '',
      priceErrorHeader: '',
      processFee: '',
      purificationFee: '',
      remainingMaterials: '',
      shippingOptionFee: '',
      totalPrice: '',
      wells: '',
    },
  ],
  plateShippingResponse: {
    listExcessMaterial: [
      'PLATE_96_SHALLOW_PCR_100',
      'PLATE_96_SHALLOW_200',
      'PLATE_96_DEEP_400',
      'PLATE_96_DEEP_800',
      'Shallow_well_40',
      'other',
    ],
    listProductPackage: [''],
    listShipment: ['Ambient', 'Ice', 'Dry Ice'],
  },
  productInformation: {
    brand: '',
    companionProducts: [''],
    currencyFormat: '',
    decimalSeparator: '',
    instructions: '',
    packageType: '',
    prefixCurrecny: true,
    productType: '',
    shippingOptions: [''],
    thousandSeparator: '',
    thousandSpacing: '',
    typeCode: '',
  },
  sessionData: [
    {
      amount: '',
      applyToAll: false,
      biTubeWellList: [
        {
          additionalComments: '',
          amount: '',
          antisenceBaseCount: 0,
          antisenceFiveMod: '',
          antisenceName: '',
          antisenceSequence: '',
          antisenceThreeMod: '',
          antisenseGcContent: '',
          antisenseMeltingTemparature: '',
          antisenseMolecularWeight: '',
          antisensePrimerDimer: '',
          antisenseSecondaryStructure: '',
          autoGenerateOligo: false,
          autoValidation: false,
          baseCount: 0,
          column: '',
          comments: '',
          concentration: '',
          countryCode: '',
          customerAntisenseOverHang: '',
          customerOverhang: '',
          fiveMod: '',
          format: '',
          gcContent: '',
          id: 0,
          isOverridden: false,
          listError: [],
          listWarning: [],
          meltingTemparature: '',
          molecularWeight: '',
          name: '',
          orderItemId: '',
          packageType: '',
          pageNo: 0,
          primerDimer: '',
          productType: '',
          purification: '',
          row: '',
          scale: '',
          secondaryStructure: '',
          senseNameCheck: false,
          sequence: '',
          shipping: '',
          technicalAntisenceSequence: '',
          technicalSequence: '',
          terms: false,
          threeMod: '',
          tubes: 0,
        },
      ],
      category: '',
      channelType: 0,
      concentration: '',
      countOfWells: 0,
      countryCode: '',
      daughterPlateCount: '',
      format: '',
      isAmountSelected: false,
      isConcentrationOther: false,
      isConcentrationSelected: false,
      isCSR: false,
      isCSRSupervisor: false,
      isOverridden: false,
      isPackageTypeOther: false,
      isShippingOverridden: false,
      isSpecificationsOverridden: false,
      material: '',
      maxAmount: '',
      minAmount: '',
      packageType: '',
      pageNo: 0,
      plateCopiesRange: '',
      plateId: 1,
      plateName: '',
      plateNameError: [],
      plateType: '',
      productType: '',
      purification: '',
      researcher: '',
      researcherNameError: [],
      scale: '',
      selectedPackageType: '',
      shipping: '',
      stockPlate: '',
      totalBaseCount: 0,
      wellList: [
        {
          additionalComments: '',
          amount: '',
          baseCount: 0,
          category: '',
          column: '',
          comments: '',
          concentration: '',
          countryCode: '',
          epsilon: 0,
          excessMaterial: false,
          fiveMod: '',
          flag: 0,
          format: '',
          gcContent: '',
          id: 0,
          isOverridden: false,
          listError: [],
          listWarning: [],
          meltingTemparature: '',
          molecularWeight: '',
          name: '',
          oligoId: 0,
          orderItemId: '',
          other: '',
          packageType: '',
          pageNo: 0,
          primerDimer: '',
          productType: ' ',
          purification: '',
          row: '',
          scale: ' ',
          secondaryStructure: '',
          sequence: '',
          shipping: '',
          technicalSequence: '',
          terms: false,
          threeMod: '',
          tubes: 1,
          wellType: 0,
        },
      ],
      wellType: 0,
    },
  ],
  specificationCalculationInput: {
    amount: '',
    category: '',
    concentration: '',
    daughterPlateNumber: '0',
    fiveMod: '',
    format: 'DRY',
    isAmountChanged: false,
    isamountValidate: false,
    isConcentrationChanged: false,
    isConcentrationValidate: false,
    isOverriden: false,
    isVolumeChanged: false,
    listScaleFromRules: [''],
    maxAmount: 0,
    maxConcentration: 0,
    maxVolume: 0,
    plateType: 'STANDARD',
    purification: '',
    scale: '',
    sequence: 'AAAAAAAAAAAA',
    threeMod: '',
    wellType: 96,
  },
  specificationCalculationResponse: {
    calculatedValues: {
      amount: '',
      daughterPlateRange: -1,
      maxAmount: 0,
      maxConcentration: 0,
      maxVolume: 0,
      minVolume: 10,
      scale: '',
    },
    errorValues: [],
  },
  stepNo: 0,
  totalValidation: [
    {
      biTubeWellList: [
        {
          countryCode: '',
          errorType: '',
          id: 1,
          listError: [],
          listWarning: [],
          oligoId: 1,
        },
      ],
      error: '',
      wellList: [
        {
          countryCode: '',
          errorType: '',
          id: 1,
          listError: [],
          oligoId: 1,
        },
      ],
    },
  ],
  wellList: [
    {
      additionalComments: '',
      amount: '',
      baseCount: 0,
      category: '',
      column: '',
      comments: '',
      concentration: '',
      countryCode: '',
      epsilon: 0,
      excessMaterial: false,
      fiveMod: '',
      flag: 0,
      format: '',
      gcContent: '',
      id: 0,
      isOverridden: false,
      listError: [],
      listWarning: [],
      meltingTemparature: '',
      molecularWeight: '',
      name: '',
      oligoId: 0,
      orderItemId: '',
      other: '',
      packageType: '',
      pageNo: 0,
      primerDimer: '',
      productType: '',
      purification: '',
      row: '',
      scale: ' ',
      secondaryStructure: '',
      sequence: '',
      shipping: '',
      technicalSequence: '',
      terms: false,
      threeMod: '',
      tubes: 1,
      wellType: 0,
    },
  ],
  wellSpecifications: [
    {
      id: 0,
      listAmount: ['1', '2', '10'],
      listFormat: ['DRY', 'LIQUID', 'TE', 'TRIS'],
      listPurification: ['DESALT', 'RP1', 'HPLC'],
      listScale: ['0.0500 UMO', '0.2000 UMO', '1.0000 UMO', '0.0250 UMO'],
    },
  ],
}

type Action =
  | { type: 'INIT' }
  | { type: 'UPDATE_INPUT'; data: [SessionData] }
  | { type: 'UPDATE_ERROR_DATA'; data: RuleValidationPlateData }
  | { type: 'UPDATE_ERROR_DATA_MIXED'; data: RuleValidationPlateDataMixed }
  | { type: 'UPDATE_ERROR_DATA_DUPLEX'; data: RuleValidationDuplexData }
  | { type: 'UPDATE_ERROR_RESPONSE'; data: RuleValidationPlateResponse }
  | {
      type: 'UPDATE_ERROR_RESPONSE_MIXED'
      data: RuleValidationPlateResponseMixed
    }
  | { type: 'UPDATE_CURRENT_PLATE_INDEX'; data: number }
  | { type: 'UPDATE_TOTALVALIDATION'; data: [PlateTotalValidation] }
  | {
      type: 'UPDATE_WELLSPECIFICATION_VALIDATION'
      data: [WellSpecificationResponse]
    }
  | { type: 'UPDATE_INTERSECTION_VALUES'; data: IntersectionValues }
  | {
      type: 'UPDATE_SPECIFICATION_CALCULATION_INPUT'
      data: SpecificationCalculationInput
    }
  | {
      type: 'UPDATE_SPECIFICATION_CALCULATION_RESPONSE'
      data: SpecifictionCalculationResponse
    }
  | { type: 'UPDATE_VALIDATE_PLATE_SHIPPING'; data: PlateShippingResponse }
  | { type: 'UPDATE_PLATE_PRICE'; data: PlatePriceCallResponse[] }
  | { type: 'SET_PRODUCT_INFORMATION'; data: ProductInformationResponse }
  | { type: 'SET_PAGE_ERROR'; data: string }
  | { type: 'SET_STEP_NO'; data: number }
  | { type: 'SET_MINIMUM_WELLS_ERROR'; data: boolean }
  | { type: 'IS_PAGE_LOAD'; data: boolean }
  | { type: 'IS_PLATE_DELETED'; data: boolean }

export interface ContextProps {
  state: PlateState
  dispatch: ({ type, data }) => void
}

export function reducer(state: PlateState, action: Action): PlateState {
  const keys = {
    UPDATE_INPUT: 'sessionData',
    UPDATE_ERROR_DATA: 'errorData',
    UPDATE_ERROR_DATA_MIXED: 'errorDataMixed',
    UPDATE_ERROR_DATA_DUPLEX: 'errorDataDuplex',
    UPDATE_ERROR_RESPONSE: 'errorResponseJson',
    UPDATE_ERROR_RESPONSE_MIXED: 'errorResponseJsonMixed',
    SET_STEP_NO: 'stepNo',
    UPDATE_CURRENT_PLATE_INDEX: 'currentPlateIndex',
    UPDATE_TOTALVALIDATION: 'totalValidation',
    UPDATE_WELLSPECIFICATION_VALIDATION: 'wellSpecifications',
    UPDATE_INTERSECTION_VALUES: 'intersectionValues',
    UPDATE_SPECIFICATION_CALCULATION_INPUT: 'specificationCalculationInput',
    UPDATE_SPECIFICATION_CALCULATION_RESPONSE:
      'specificationCalculationResponse',
    UPDATE_VALIDATE_PLATE_SHIPPING: 'plateShippingResponse',
    UPDATE_PLATE_PRICE: 'platePriceCall',
    SET_PRODUCT_INFORMATION: 'productInformation',
    SET_PAGE_ERROR: 'pageError',
    SET_MINIMUM_WELLS_ERROR: 'minimumWellsError',
    IS_PAGE_LOAD: 'isPageLoad',
    IS_PLATE_DELETED: 'isPlateDeleted',
  }

  if (keys[action.type] && action.type !== 'INIT') {
    const newState = { ...state }
    newState[keys[action.type]] = action.data
    return newState
  } else {
    return initialState
  }
}
